import React, { memo } from 'react';
import cn from 'clsx';
import { LinkWithGAClickButton, Typography, SectionSubTitle } from 'common/components';
import { KitchenStylesInfoBlock } from './info-block-types';
import {
  selectionBlockInfo,
  selectionBlockTitle,
  selectionBlockText,
  selectionBlockButton,
} from './info-block-styles';

type InfoBlockProps = {
  regionId: string | undefined;
  block: KitchenStylesInfoBlock;
  commonClassName?: string;
};

export const InfoBlock: React.FC<InfoBlockProps> = memo(({ regionId = '34', block, commonClassName }) => {
  const { className, title, href, target, text, btnText, elementName } = block;
  const finalHref = href.replace('defaultRegion', regionId);

  return (
    <LinkWithGAClickButton
      elementBlock="landingProektKuhniStili"
      elementName={elementName}
      elementText={btnText}
      className={cn(commonClassName, selectionBlockInfo, className)}
      title={title}
      href={finalHref}
      target={target}>
      <SectionSubTitle className={selectionBlockTitle} margin="s">
        {title}
      </SectionSubTitle>
      {text && (
        <Typography className={selectionBlockText} variant="m" size="body_short">
          {text}
        </Typography>
      )}
      <Typography className={selectionBlockButton} variant="m" size="body_accent" color="text-invert">
        {btnText}
      </Typography>
    </LinkWithGAClickButton>
  );
});
